import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m 21.615,2.21152 c 0.2892,0.22552 0.4317,0.5912 0.3714,0.95289 l -3,17.99999 c -0.0539,0.3237 -0.2632,0.6003 -0.5601,0.7402 -0.2968,0.1399 -0.6434,0.1252 -0.9273,-0.0392 L 12.2911,18.8503 9.31781,23.0755 C 9.06689,23.4321 8.61386,23.585 8.19818,23.4534 7.78251,23.3218 7.50001,22.936 7.50001,22.5 V 16.0803 L 1.00387,12.3683 C 0.675457,12.1806 0.481035,11.8237 0.501466,11.446 0.521897,11.0683 0.753683,10.7345 1.10042,10.5833 L 20.6004,2.08331 C 20.9366,1.93679 21.3259,1.98599 21.615,2.21152 Z M 9.50001,19.3413 10.5534,17.8443 9.50001,17.2345 Z M 8.33298,14.2528 16.5592,6.02663 3.72632,11.6204 Z m 11.16762,-8.33918 -9.3731,9.37308 7.1236,4.1242 z"
  }));
});
var DescriptiveDelivered = AbstractIcon.withComponent(Icon);
DescriptiveDelivered.displayName = 'DescriptiveDelivered';
export default DescriptiveDelivered;